export default __webpack_public_path__ + "static/media/DSC_7512.b10ea04a.jpg";